import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import { appendPath } from '@truqc/content-path';
import { convertToAbsolutePath } from '../utils';
import onChange from './onChange';
import { newPathSelector } from '../selectors';
export const buildLogPatch = (userFullName, changes, path, breadcrumbs, latitude, longitude) => _objectSpread(_objectSpread({
  // remove the extraneous info from the object passed in to make changes
  // Generate the log value
  _created: moment().toISOString(),
  user: userFullName
}, changes), {}, {
  path,
  contentPath: path,
  breadcrumbs,
  latitude,
  longitude
});
const logValue = (state, props) => async changes => {
  var _state$login, _state$login2;
  const onChangeFunc = onChange(state, props);
  const logContentPath = props.logContentPath,
    breadcrumbs = props.breadcrumbs;
  // Ensure the component needs logging
  if (typeof logContentPath !== 'string') {
    return;
  }
  const _state$login$user = state.login.user,
    firstName = _state$login$user.firstName,
    lastName = _state$login$user.lastName;
  const userFullName = "".concat(firstName, " ").concat(lastName);
  const latitude = (state === null || state === void 0 || (_state$login = state.login) === null || _state$login === void 0 || (_state$login = _state$login.geolocation) === null || _state$login === void 0 ? void 0 : _state$login.latitude) || undefined;
  const longitude = (state === null || state === void 0 || (_state$login2 = state.login) === null || _state$login2 === void 0 || (_state$login2 = _state$login2.geolocation) === null || _state$login2 === void 0 ? void 0 : _state$login2.longitude) || undefined;
  const path = newPathSelector(state, props);
  const logPath = convertToAbsolutePath(logContentPath, path);
  const fullLogPath = appendPath(logPath, uuid());

  // remove the extraneous info from the object passed in to make changes
  // Generate the log value
  const logPatch = buildLogPatch(userFullName, changes, path, breadcrumbs, latitude, longitude);
  const logChange = {
    path: fullLogPath,
    value: logPatch,
    changeModifiers: {
      // do not invoke actions or events on audit trail.
      preActions: [],
      postActions: [],
      preEvents: [],
      postEvents: []
    }
  };
  // Dispatch the log event.
  await onChangeFunc(logChange);
};
export default logValue;